import axios from 'axios';

window._axiosPromiseArr = []
axios.interceptors.request.use(
    config => {
        config.cancelToken = new axios.CancelToken(cancel => {

            window._axiosPromiseArr.push({ cancel })

        })
        return config
    },
    error => {
        console.log(error)
        return Promise.reject(error)
    }
);
export const ajaxPost = function (url, params) {
  // console.log(params);
    return new Promise((resolve, reject) => {
        axios
            .post(url, params,{ headers: {'X-Requested-With': 'XMLHttpRequest','Content-Type':'application/json'},withCredentials: false})
            .then((res) => {
                resolve(res.data)
            })
            .catch(() => {
                reject('error')
            })
    })
}
export const ajaxGet= function (url, params) {
    return new Promise((resolve, reject) => {
        axios
            .get(url, params)
            .then((res) => {
                resolve(res.data)
            })
            .catch(() => {
                reject('error')
            })
    })
}



// WEBPACK FOOTER //
// ./src/js/config/ajax.js